// extracted by mini-css-extract-plugin
export default {"page":"BUz7e","inner":"Yoh4Y","main":"X5iov","actions":"P7auk"};